var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "presentation",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.75A2.75 2.75 0 0 1 2.75 0H10a8 8 0 1 1 0 16H2.75A2.75 2.75 0 0 1 0 13.25V2.75Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.433 7.516a1.113 1.113 0 1 0 0-2.226 1.113 1.113 0 0 0 0 2.226ZM5.273 12.004a1.683 1.683 0 0 1-1.685-1.684V9.004a.845.845 0 1 1 1.69 0v3h-.005Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2.75C1 1.784 1.784 1 2.75 1H10a7 7 0 1 1 0 14H2.75A1.75 1.75 0 0 1 1 13.25V2.75ZM2.75 2a.75.75 0 0 0-.75.75v10.5c0 .414.336.75.75.75H10a6 6 0 0 0 0-12H2.75Z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55 4.56V12h3.238c2.94 0 4.214-1.66 4.214-4.009C14.002 5.744 12.727 4 9.788 4H7.11a.562.562 0 0 0-.561.56Z",
    fill: "#E60073"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeal);
export default __webpack_public_path__ + "static/media/ideal.608d5ba5730f82c25f122960ccaa9836.svg";
export { ForwardRef as ReactComponent };